import { updatesItems } from '@/mocks/anime';

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            关注51动漫网最新资源更新与站点公告
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updatesItems.map((item, idx) => (
            <div key={item.id} className="relative pl-8 pb-8 last:pb-0">
              {idx < updatesItems.length - 1 && (
                <div className="absolute left-[11px] top-8 bottom-0 w-0.5 bg-background-300/60"></div>
              )}
              <div className="absolute left-0 top-1.5 w-6 h-6 rounded-full bg-primary-100 border-2 border-primary-300 flex items-center justify-center">
                <div className="w-2 h-2 rounded-full bg-primary-500"></div>
              </div>
              <div className="bg-background-50 rounded-xl border border-background-200/60 p-4 md:p-5 hover:border-primary-200/50 transition-colors cursor-pointer">
                <div className="flex items-center gap-3 flex-wrap mb-2">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-950 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}